export const ZoonIcon = () => {
  return (
    <>
      <svg
        width='19'
        height='20'
        viewBox='0 0 19 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'>
        <title>Zoon Icon</title>
        <path
          d='M3.96094 5.26828H11.9994'
          stroke='#1F7CAB'
          stroke-width='1.5'
          stroke-linecap='round'
        />
        <path
          d='M3.96094 8.68292H9.46091'
          stroke='#1F7CAB'
          stroke-width='1.5'
          stroke-linecap='round'
        />
        <path
          d='M12.846 17.2195C13.7437 17.2195 14.6046 16.8597 15.2393 16.2194C15.874 15.579 16.2306 14.7105 16.2306 13.8049C16.2306 12.8992 15.874 12.0307 15.2393 11.3904C14.6046 10.75 13.7437 10.3902 12.846 10.3902C11.9484 10.3902 11.0875 10.75 10.4528 11.3904C9.81802 12.0307 9.46143 12.8992 9.46143 13.8049C9.46143 14.7105 9.81802 15.579 10.4528 16.2194C11.0875 16.8597 11.9484 17.2195 12.846 17.2195Z'
          stroke='#1F7CAB'
          stroke-width='1.5'
        />
        <path
          d='M17.5003 18.5L15.2402 16.219'
          stroke='#1F7CAB'
          stroke-width='1.5'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M16.2307 9.23183V1H1V18.0732H8.50958'
          stroke='#1F7CAB'
          stroke-width='1.5'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </svg>
    </>
  );
};
